import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="retro-header">
      <Link to="/" className="header-home-link">
        <div className="header-title">
        <div className="header-sprout"></div>
        SAM DE ALFARO
        </div>
      </Link>
      <nav className="header-nav">
        <a href="/ricette" className="header-link">RICETTE</a>
        <a href="/briscola" className="header-link">BRISCOLA</a>
        <a href="/Resume.pdf" target="_blank" className="header-link">RÉSUMÉ</a>
      </nav>
    </header>
  );
};

export default Header;